if (!customElements.get('cart-upsell-recommendations')) {
  class CartUpsellRecommendations extends Carousel {
    constructor() {
      super();
      this.productIds = JSON.parse(this.dataset.productIds) || [];
      this.intent = this.dataset.intent;
      this.limit = Number(this.dataset.limit) || 8;
    }

    connectedCallback() {
      if (!this.intent) return;

      const handleIntersection = async (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        try {
          this.querySelector(".shimmer-container")?.classList.remove("hidden");

          const fetchLimit = Math.max(this.limit * 8, 50);

          const urls = this.productIds.map(
            (id) =>
              `${routes.product_recommendations_url}?product_id=${id}&limit=${fetchLimit}&intent=${this.intent}&section_id=upsell-recommendations`
          );

          console.log("Cart product IDs:", this.productIds);
          console.log("Display limit:", this.limit);
          console.log("Requested fetch limit:", fetchLimit);

          const responses = await Promise.all(urls.map((url) => fetch(url)));

          const allRecommendations = [];
          const seenHandles = new Set();

          for (let response of responses) {
            const text = await response.text();
            const html = document.createElement("div");
            html.innerHTML = text;

            const totalFetchedCards = html.querySelectorAll("[data-upsell-card]").length;
            const totalB2BCards = html.querySelectorAll(
              '[data-upsell-card][data-b2b-only="true"]'
            ).length;

            const recommendations = Array.from(
              html.querySelectorAll('[data-upsell-card]:not([data-b2b-only="true"])')
            );

            console.log("Total fetched cards:", totalFetchedCards);
            console.log("Fetched B2B-only cards:", totalB2BCards);
            console.log("Fetched non-B2B cards:", recommendations.length);

            for (const card of recommendations) {
              const productHandle = card.getAttribute("data-product-handle");

              if (productHandle) {
                if (!seenHandles.has(productHandle)) {
                  seenHandles.add(productHandle);
                  allRecommendations.push(card);
                }
              } else {
                allRecommendations.push(card);
              }
            }
          }

          console.log("Unique non-B2B cards collected:", allRecommendations.length);

          const finalRecommendations = allRecommendations.slice(0, this.limit);
          const fragment = document.createDocumentFragment();

          for (const card of finalRecommendations) {
            fragment.appendChild(card);
          }

          this.querySelector(".splide__list")?.appendChild(fragment);

          const finalRenderedCount = this.querySelectorAll("[data-upsell-card]").length;
          console.log("Final rendered cards:", finalRenderedCount);

          if (finalRenderedCount) {
            this.classList.add(
              "tw-py-5",
              "tw-mb-16",
              "tw-border-t",
              "tw-border-solid",
              "tw-border-gray-300"
            );
            this.querySelector("h3")?.classList.remove("hidden");
            this.querySelector(".shimmer-container")?.classList.add("hidden");
            this.refreshSlider();
          } else {
            this.querySelector(".shimmer-container")?.classList.add("hidden");
            this.style.display = "none";
          }
        } catch (error) {
          console.error("Cart upsell recommendations error:", error);
          this.querySelector(".shimmer-container")?.classList.add("hidden");
        }
      };

      new IntersectionObserver(handleIntersection.bind(this)).observe(this);
    }
  }

  customElements.define("cart-upsell-recommendations", CartUpsellRecommendations);
}